// extracted by mini-css-extract-plugin
export var button = "_mq-2";
export var card = "_mq-0";
export var closeButtonContainer = "_mq-3";
export var iconContainer = "_mq-1";